import { Component, OnInit, ElementRef, ViewChild, Output, EventEmitter } from '@angular/core';
import { GlobalConstants } from '../../../../common/constants/global.constant';
import { OemService } from '../../../../../app/core/routing/services/oem/oem.service';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { first } from 'rxjs/internal/operators/first';
import { OemConstants } from '../../../../core/routing/services/oem/constants/oem.constants'
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { RouterConstants } from '../../../../../app/core/routing/constants/app-paths.constant';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'iposcen-upload-video',
  templateUrl: './upload-video.component.html',
  styleUrls: ['./upload-video.component.scss']
})
export class UploadVideoComponent implements OnInit {
  type: any;
  autoId: any;
  videoSizeError: boolean;
  videoTypeError: any;
  videoFormatError: boolean;
  tileVideo = [];
  uploadVideoSortValue: string;
  videoFile: any;
  mediaObjects: any;
  isVideoFormat: boolean;
  videoUrl: any;
  videoCount: number;
  deleteVideoLable;
  uploadDateLable = 'Upload Date';
  fileNameLable = 'File Name';
  setLable = this.uploadDateLable;
  userId = sessionStorage.getItem('userId');
  isVideoAvailable = false;
  typeConfiguration: string = OemConstants.VIDEO_SLASH;
  @Output() readonly setSideNavValue = new EventEmitter();
  @ViewChild('VideoDeleteModal') videoDeletePopup: ElementRef;
  private ngUnsubscribe = new Subject<boolean>();
  private modalRef: NgbModalRef;
  private modalOption: NgbModalOptions = {};
  deleteVideoData: any;
  fileSizeError: any;
  videoTimeError: boolean;
  toolTipText = 'Delete';
  videoPlaying: HTMLVideoElement;
  isDeleteDisable: boolean;
  noVideo: boolean;
  videoLabel = $localize`:@@upload-video.header.sing:Video`;

  constructor(
    private oemservice: OemService,
    private sanitizer: DomSanitizer,
    private router: Router,
    private modalService: NgbModal,
  ) { }

  ngOnInit(): void {
    this.type = OemConstants.TILE_Video;
    this.autoId = this.oemservice.getAutoId();
    this.videoCount = this.tileVideo.length;
    this.noVideo = false;
    this.getAllVideoByAutoId();
  }
  getAllVideoByAutoId() {
    this.tileVideo = [];
    this.oemservice.getAllAssetsByAutoId(this.type)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(getAllVideoResponse => {
        const getVideoByAutoId = getAllVideoResponse;
        if (getVideoByAutoId.assets.length === 0){
          this.noVideo = true;
        }else{
          this.noVideo = false;
        }
        const counter = 0;
        getVideoByAutoId.assets.forEach((assets, index, arrayData) => {
          const reader = new FileReader();
          const VideoViewModel = assets;
          this.oemservice.getAssetByAutoIdAndAssetId(assets.assetID, OemConstants.SLASH_VIDEO)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(videoData => {
              reader.onload = _event => {
                VideoViewModel.videoData = reader.result;
                VideoViewModel.fileName = assets.assetName;
                this.tileVideo.push(VideoViewModel);
                if(this.tileVideo.length === 0){
                  this.noVideo = false;
                }else{
                  this.noVideo= true;
                }
                
                this.tileVideo.forEach(ele => {
                  ele.updatedTime = new Date(ele.updatedTime);
                  ele.updateTimeDisplay = new Date(ele.updatedTime).toLocaleString()
                    .replace(',', '');
                })
                this.videoCount = this.tileVideo.length;
                if (this.videoCount === arrayData.length) {
                  this.changeSortType('date');
                }
              };
              if (videoData) {
                reader.readAsDataURL(videoData);
              }

            });
        })
      });
  }
  changeSortType(data) {
    this.setLable = data === 'date' ? this.uploadDateLable : this.fileNameLable;
    if (data === 'name') {
      this.tileVideo.sort((e1, e2): number => {
        if (e1.fileName < e2.fileName) {
          return -1;
        }
        return 0;
      })
    } else {
      this.tileVideo.sort((e1, e2): number => {
        if (new Date(e1.updateTimeDisplay) < new Date(e2.updateTimeDisplay)) {
          return -1;
        }
        return 0;
      })
    }
  }
  getShortFileName(fileName: string): string {
    let finalName: string;
    var str = fileName;
    var arr = str.split(".");
    var lastVal = arr.pop();
    var firstVal = arr.join(".");

    if (firstVal.length > 12) {
      let flname = firstVal;
      let extension = lastVal;
      flname = firstVal.substring(0, 12);
      finalName = `${flname}...${extension}`;
    } else {
      finalName = fileName;
    }
    return finalName;
  }
  deleteVideo() {
    this.oemservice.deleteVideo(this.deleteVideoData.assetID)
      .pipe()
      .subscribe(res => {
        this.close();
        this.tileVideo = [];
        this.getAllVideoByAutoId();
        this.videoCount -= 1;
      }, err => {
        this.isDeleteDisable = true;
      });
  }
  checkVideoPlay(data) {
    data.preventDefault();
    if (!this.videoPlaying) {
      this.videoPlaying = data.target;
      this.videoPlaying.play();
    } else {
      if (data.target !== this.videoPlaying) {
        this.videoPlaying.pause();
        this.videoPlaying = data.target;
        this.videoPlaying.play();
      }
    }
  }
  open(data) {
    this.deleteVideoLable = data.fileName;
    this.deleteVideoData = data;
    this.modalOption.backdrop = 'static';
    this.modalOption.keyboard = false;
    this.isDeleteDisable = false;
    this.modalRef = this.modalService.open(this.videoDeletePopup, this.modalOption);
    this.modalRef.result.then();
  }

  close() {
    this.modalRef.close();
    this.deleteVideoData = '';

  }

  dismiss() {
    this.modalRef.dismiss();
    this.deleteVideoData = '';
  }

  goBack() {
    this.router.navigate([RouterConstants.MODEL_SKU_INFO_LINK]);
  }

  goNextTab() {
    this.setSideNavValue.emit('upload_logo');
  }
  processFile(event, files) {
    this.videoTimeError = false;
    this.fileSizeError = false;
    this.videoTypeError = false;
    this.videoFile = event.target.files;
    const reader = new FileReader();
    const file: File = files.files[0];
    const fileType = file?.type?.split('/')[1];
    reader.readAsDataURL(this.videoFile[0]);
    if (this.videoFile[0]?.type !== GlobalConstants.FILE_TYPE_VIDEO_MP4) {
      this.videoTypeError = true;
      this.isVideoFormat = false;
    } else {
      if (this.videoFile && this.videoFile[0]) {
        this.isVideoFormat = true;
        this.videoUrl = '';
        this.videoUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(this.videoFile[0]));
      }
      if (file.size <= GlobalConstants.UPLOAD_VIDEO_MAX_SIZE_OEM) {
        this.fileSizeError = false;
        reader.onload = _event => {
          let video = document.createElement('video');
          video.preload = 'metadata';
          video.src = _event.target.result.toString();
          video.onloadedmetadata = () => {
            if (video.duration <= GlobalConstants.UPLOAD_VIDEO_MAX_TIME_OEM) {
              const assets = {
                type: `${this.typeConfiguration}${fileType}`,
                assetName: file.name,
                assetCategory: OemConstants.TILE_Video
              };
              this.oemservice.uploadAssets(JSON.stringify(assets))
                .pipe(takeUntil(this.ngUnsubscribe))
                .pipe()
                .subscribe(createAsset => {
                  const createTileVideoResponse = createAsset;
                  const assetVideoViewModel = createTileVideoResponse.assets;
                  //PATCH Endpoint to insert the downloadURL
                  this.oemservice.updateDownloadURL(this.autoId, createAsset.assets.assetID, fileType, OemConstants.TILE_Video.toLowerCase())
                    .pipe(takeUntil(this.ngUnsubscribe))
                    .subscribe(res => {

                    })
                  this.oemservice.uploadImage(file, createAsset.assets.assetID, file.name.split('.').pop(), this.autoId, OemConstants.VIDEO_ASSETS_PATH)
                    .pipe(takeUntil(this.ngUnsubscribe))
                    .pipe(first())
                    .subscribe(() => {
                      assetVideoViewModel.videoData = _event.target.result;
                      assetVideoViewModel.fileName = file.name;
                      assetVideoViewModel.updatedTime = new Date(assetVideoViewModel.updatedTime);
                      assetVideoViewModel.updateTimeDisplay = new Date(assetVideoViewModel.updatedTime).toLocaleString()
                        .replace(',', '');
                      this.tileVideo.push(assetVideoViewModel);
                      this.videoCount = this.tileVideo.length;
                    });
                });
            } else {
              this.videoTimeError = true;
            }
          }
        };
      } else {
        this.fileSizeError = true;
      }
    }
  }
}
